import { i18nFn, Stashboard } from '@springbig/shared';
import { HStack, Pressable, VStack } from 'native-base';
import { CardTitle } from '~/pages/homePage/components/CardTitle';
import { Caption } from '~/shared/Typography';
import React from 'react';
import { useAppNavigate } from '~/pages';
import { useHomePageStyles } from '~/shared/styles';
import { SpIcon } from '~/shared/Icon';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Image from '~/shared/Image';
import { CardBottomLink } from '~/pages/homePage/components/CardBottomLink';

type MessagesProps = {
    data: Array<Stashboard>;
    t: i18nFn;
};

export const Messages = ({
    data,
    t,
}: MessagesProps) => {

    const { navigate, params } = useAppNavigate();
    const { icon, primary_color } = useHomePageStyles();

    return (
        <VStack space={4}>
            <CardTitle
                title={t('home_page.messages.title')}
                icon={'faComment'}
            />
            <VStack space={2}>
                { data.map((item, index) =>

                    <HStack
                        key={index}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        bg={primary_color}
                        rounded={'2xl'}
                        minH={20}
                    >
                        { item.stashboard_media.length > 0 &&
                            <Image
                                w={20}
                                h={20}
                                roundedLeft={'2xl'}
                                uri={item.stashboard_media[0]?.result_url}
                            />
                        }
                        <Caption
                            px={4}
                            numberOfLines={3}
                            ellipsizeMode={'tail'}
                        >
                            { item.sms_content }
                        </Caption>
                        <VStack w={12} justifyContent={'center'} alignItems={'center'}>
                            <Pressable
                                onPress={() =>

                                    navigate(`w/${params.wallet_id}/messages/${item._key}`)
                                }
                            >
                                <SpIcon icon={faChevronRight} size={36} color={icon} />
                            </Pressable>
                        </VStack>
                    </HStack>
                )}
            </VStack>
            { data.length === 0 ?
                <CardBottomLink t={t} text={'home_page.messages.previous'} link={'messages'} />
                :
                <CardBottomLink t={t} text={'home_page.view_more'} link={'messages'} />
            }
        </VStack>
    );
};
